export default __webpack_public_path__ + "static/media/ic-addphoto-gray-24-px.33ba0302.svg";